import React from 'react';
import AnimatedSection from '../ui/AnimatedSection';
import { Quote } from 'lucide-react';
import { testimonials } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const TestimonialsSection = () => {
  const { pick } = useLanguage();
  return (
    <section className="section-padding-lg bg-[#1a1c1b]">
      <div className="container-swg">
        <AnimatedSection>
          <div className="max-w-4xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="relative">
                <Quote className="w-16 h-16 text-[#5B7A8A]/20 absolute -top-4 -left-4" />
                <blockquote className="text-xl md:text-2xl text-white leading-relaxed mb-8 relative z-10">
                  "{pick(testimonial.quote)}"
                </blockquote>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#5B7A8A] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold">{testimonial.author.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-white font-semibold">{testimonial.author}</p>
                    <p className="text-[#9AACB8] text-sm">{pick(testimonial.role)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default TestimonialsSection;
